import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
const useStyles = makeStyles(theme => ({
    stat: {
        fontSize: '3em'
    },
    label: {
        marginTop: '-1em',
        marginBottom: '1em',
        textTransform: 'uppercase'
    }
}));
function Statistic(props) {
    const classes = useStyles();
    const { stat, label } = props;
    return (React.createElement(Grid, { container: true, direction: 'column', justify: 'center' },
        React.createElement(Grid, { item: true },
            React.createElement(Typography, { className: classes.stat }, stat)),
        React.createElement(Grid, { item: true },
            React.createElement(Typography, { className: classes.label }, label))));
}
export default Statistic;
//# sourceMappingURL=Statistic.js.map